import { padding, margin } from 'polished'
import { colorDescriptionMap } from 'design-framework/utils/helpers'
import { __animatingFrame } from 'design-framework/common/ui/PlaceHolder'

export const __pills = ({
	backgroundColor,
	theme,
	scrollablePills,
	hasCarousel,
	hideScrollbar,
	isDesktop,
	quickfilter,
}) => ({
	width: 'auto',
	backgroundColor,
	overflowX: 'auto',
	overflowY: 'hidden',
	height: 'auto',
	...theme.regularBaseFont,
	'& ul': {
		listStyleType: 'none',
		display: 'flex',
		flexWrap: `${scrollablePills ? 'nowrap' : 'wrap'}`,
		...padding('3', '0'),
		margin: '0',
		color: theme.primary(theme).backgroundColor,
		width: hasCarousel ? 'fit-content' : '100%',
		justifyContent: isDesktop ? 'center' : 'flex-start',
		extend: [
			{
				condition: quickfilter,
				style: {
					...padding(0),
				},
			},
			{
				condition: quickfilter && scrollablePills,
				style: {
					width: 'fit-content',
				},
			},
		],
	},
	extend: [
		{
			condition: hasCarousel,
			style: {
				overflowX: 'visible',
				overflowY: 'visible',
				...padding(15, 0),
			},
		},
		{
			condition: hideScrollbar,
			style: {
				'-ms-overflow-style': 'none' /* IE and Edge */,
				scrollbarWidth: 'none',
				'&::-webkit-scrollbar': {
					display: 'none',
				},
			},
		},
	],
})

export const __listItem = ({
	isSquared,
	isActive,
	theme,
	clickable,
	disable,
	customColor,
	status,
	quickfilter,
	loading,
	subText,
	customStyle,
	isDesktop,
	marginStyle,
	noFirstLastPillMargin,
}) => ({
	userSelect: 'none',
	cursor: 'pointer',
	...padding('9', '10'),
	textTransform: 'capitalize',
	...margin('0', theme.spaces[4], '5', '0'),
	borderWidth: '1',
	borderStyle: 'solid',
	borderColor: theme.primary(theme).backgroundColor,
	color: theme.primary(theme).backgroundColor,
	borderRadius: '500',
	whiteSpace: 'noWrap',
	fontSize: theme.font.size14,
	backgroundColor: isDesktop ? theme.colors.white : 'transparent',
	pointerEvents: `${clickable ? 'initial' : 'none'}`,
	...theme.regularBaseFont,
	extend: [
		{
			condition: quickfilter,
			style: {
				...margin('0', '10', '0', '0'),
				...padding('7', '12'),
				borderColor: !isActive && theme.colors.lightGrey2,
				color: !isActive && theme.primary(theme).backgroundColor,
				backgroundColor: theme.colors.white,
				fontSize: theme.font.size12,
			},
		},
		{
			condition: quickfilter && !noFirstLastPillMargin,
			style: {
				'&:first-child': {
					marginLeft: 15,
				},
				'&:last-child': {
					marginRight: 15,
				},
			},
		},
		{
			condition: loading,
			style: __animatingFrame,
		},
		{
			condition: isSquared && !customStyle,
			style: {
				borderRadius: theme.primary(theme).borderRadius,
				borderColor:
					customColor || theme.primary(theme).backgroundColor,
				color: customColor || theme.primary(theme).backgroundColor,
			},
		},
		{
			condition: customStyle,
			style: {
				borderRadius: theme.primary(theme).borderRadius,
				borderColor: theme.primary(theme).backgroundColor,
				color: theme.primary(theme).backgroundColor,
			},
		},
		{
			condition: !disable && !loading && isActive,
			style: {
				backgroundColor:
					customColor || theme.primary(theme).backgroundColor,
				borderColor:
					customColor || theme.primary(theme).backgroundColor,
				color: theme.colors.white,
			},
		},
		{
			condition: disable,
			style: {
				borderRadius: theme.primary(theme).borderRadius,
				border: `1px solid ${theme.colors.lightGrey4}`,
				color: theme.colors.darkGrey5,
				textDecoration: 'line-through',
			},
		},
		{
			condition:
				!isActive && colorDescriptionMap(theme)[status] !== undefined,
			style: {
				borderRadius: theme.primary(theme).borderRadius,
				color:
					colorDescriptionMap(theme)[status] &&
					colorDescriptionMap(theme)[status].color,
				borderColor:
					colorDescriptionMap(theme)[status] &&
					colorDescriptionMap(theme)[status].borderColor,
			},
		},
		{
			condition:
				isActive && colorDescriptionMap(theme)[status] !== undefined,
			style: {
				borderRadius: theme.primary(theme).borderRadius,
				color: theme.colors.white,
				backgroundColor:
					colorDescriptionMap(theme)[status] &&
					colorDescriptionMap(theme)[status].color,
				borderColor:
					colorDescriptionMap(theme)[status] &&
					colorDescriptionMap(theme)[status].borderColor,
			},
		},
		{
			condition: subText,
			style: {
				marginBottom: marginStyle,
				maxHeight: '37px',
				// marginBottom: '12px',
				':after': {
					content: `"${subText}"`,
					color: theme.colors.darkGrey5,
					display: 'inline-block',
					position: 'relative',
					top: '28px',
					left: '-47px',
					width: '0px',
					fontSize: theme.font.size12,
				},
			},
		},
	],
})

export const __closeIcon = () => ({
	width: 8,
	height: 8,
	marginLeft: 8,
	marginBottom: 2,
})
